<template>
  <div class="drugInfo">
    <img v-if="!_isMobile" src="https://cdn.youjiajk.com/appfile/drugBanner.png" width="100%" />
    <img v-else src="https://cdn.youjiajk.com/appfile/drugBanner_m.png" width="100%" />
    <div :class="!_isMobile ? 'wrapperPc container' : 'wrapperMobile'">
      <div class="title">药品信息</div>
      <h2 class="nameTitle">{{dataInfo.commonName}}</h2>
      <div class="disflex">
        <img class="imgUrlStyle" :src="dataInfo.imgUrl" alt="">
        <div class="desc">
          <p>【药品名称】</p>
          <p>通用名称：{{dataInfo.commonName}}</p>
          <p v-if="dataInfo.productName">商品名称：{{dataInfo.productName}}</p>
          <p v-if="dataInfo.englishName">英文名称：{{dataInfo.englishName}}</p>
          <p v-if="dataInfo.chineseName">汉语拼音：{{dataInfo.chineseName}}</p>
          <p>【成份】{{dataInfo.ingredient}}</p>
          <p>【性状】{{dataInfo.character}}</p>
          <p v-if="dataInfo.category">【作用类别】{{dataInfo.category}}</p>
          <p v-if="dataInfo.indication">【适应症】<span v-html="dataInfo.indication"></span></p>
          <p v-if="dataInfo.specification">【规格】{{dataInfo.specification}}</p>
          <p v-if="dataInfo.function">【功能主治】{{dataInfo.function}}</p>
          <p>【用法用量】<span v-html="dataInfo.usage"></span></p>
          <p>【不良反应】<span v-html="dataInfo.adverse"></span></p>
          <p>【禁忌】<span v-html="dataInfo.taboo"></span></p>
          <p>【注意事项】<span v-html="dataInfo.announcements"></span></p>
          <p>【药物相互作用】<span v-html="dataInfo.interaction"></span></p>
          <p v-if="dataInfo.Pharmacology">【药理作用】{{dataInfo.Pharmacology}}</p>
          <p>【贮藏】{{dataInfo.depot}}</p>
          <p>【包装】{{dataInfo.packaging}}</p>
          <p>【有效期】{{dataInfo.validity}}</p>
          <p>【执行标准】{{dataInfo.standard}}</p>
          <p>【批准文号】{{dataInfo.approvalNumber}}</p>
          <p>【生产企业】{{dataInfo.manufacturer}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        _isMobile: false,
        detailInfo: [{
          commonName: '多维元素胶囊(13)',
          productName: '康耐得',
          englishName: 'Multivitamin and Elements Capsules（13）',
          chineseName: 'Duowei Yuansu Jiaonang（13）',
          ingredient: '本品为复方制剂，每粒含维生素A4000单位，维生素D400单位，维生素E11毫克，维生素C100毫克，叶酸0.8毫克，维生素B11.5毫克，维生素B21.7毫克，维生素B62.6毫克，维生素B124微克，钙58.8毫克，铁19.8毫克，锌20毫克，烟酰胺18毫克。辅料为：玉米淀粉、明胶空心胶囊。',
          character: '本品的内容物 为棕色颗粒和粉末。',
          category: '本品为维生素及矿物质类非处方药药品。',
          indication: '用于妊娠及哺乳期妇女维生素与矿物质的补充。',
          specification: '',
          function: '',
          usage: '<span>口服，成人一日1粒。</span>',
          adverse: '<span>偶见胃部不适。</span>',
          taboo: '<span>慢性肾功能衰竭、高钙血症、高磷血症伴肾性佝偻病患者禁用。</span>',
          announcements: '<p>1.严格按推荐剂量服用，不得超量。</p><p>2.本品含维生素A，可从乳汁中分泌，哺乳期妇女过量服用可致婴儿食欲不振、易激动、颅内压增高等不良反应。</p><p>3.对本品过敏者禁用，过敏体质者慎用。</p><p>4.本品性状发生改变时禁止使用。</p><p>5.请将本品放在儿童不能接触的地方。</p><p>6.如正在使用其他药品，使用本品前请咨询医师或药师。</p>',
          interaction: '<p>1.抗酸药可影响本品中维生素A的吸收，故不应同服。</p><p>2.不应与含有大量镁、钙的药物合用，以免引起高钙、高镁血症。</p><p> 3.如与其他药物同时使用可能会发生药物相互作用，详情请咨询咨询医师或药师。</p>',
          Pharmacology: '维生素和矿物质均为维持机体正常代谢和身体健康必不可少的重要物质，二者是构成多种辅酶和激素的重要成份，缺乏时可导致代谢障碍而引致多种疾病。',
          depot: '遮光，密封，阴凉处（不超过20℃）保存。',
          packaging: '铝塑泡罩包装。每盒5板，每板6粒。',
          validity: '24个月',
          standard: '国家食品药品监督管理局国家药品标准WS1-(X-061)-2006Z-2011',
          approvalNumber: '国药准字H10980252',
          manufacturer: '河北恒利集团制药股份有限公司',
          imgUrl: 'https://cdn.youjiajk.com/appfile/drug1.png'
        }, {
          commonName: '复方薄荷脑软膏',
          productName: '',
          englishName: 'Compound Mentholatum Ointment',
          chineseName: 'Fufang Bohenao Ruangao',
          ingredient: '本品为复方制剂，每克含水杨酸甲酯3.33mg、樟脑90mg、薄荷脑13.5mg、松节油0.83mg。 辅料为：桉油、凡士林。',
          character: '本品为类白色或微黄色的软膏，具芳香气，有清凉感。',
          category: '',
          indication: '用于由伤风感冒所致的鼻塞、昆虫叮咬、皮肤皲裂、轻度烧烫伤、擦伤、晒伤及皮肤瘙痒等。',
          specification: '28g',
          function: '',
          usage: '<span>外用。伤风感冒凃于鼻下；昆虫叮咬或皮肤皲裂等，凃于患处，一日3~4次。</>',
          adverse: '<span>偶见皮肤刺激症状。</span>',
          taboo: '<span>尚不明确。</span>',
          announcements: '<p>1.若伤风感冒长期未愈或同时有发烧者，不宜用本品，应到医院诊治。</p><p>2.不得用于皮肤破溃处。</p><p>3.避免接触眼睛和其他黏膜（如口、鼻等）。</p><p>4.药部位如有烧灼感、红肿等情况应停药，并将局部药物洗净，必要时向医师咨询。</p><p>5.本品含有水杨酸甲酯，婴儿不宜长期使用。</p><p>6.本品不应大面积使用。</p><p>7.对本品过敏者禁用，过敏体质者慎用。</p><p>8.本品性状发生改变时禁止使用。</p><p>9.请将本品放在儿童不能接触的地方。</p><p>10.儿童必须要成人监护下使用。</p><p>11.如正在使用其他药品，使用本品前请咨询医师或药师。</p>',
          interaction: '<span>如与其他药物同时使用可能会发生药物相互作用，详情请咨询医师或药师</span>',
          Pharmacology: '本品具有消炎、止痛和止痒作用。',
          depot: '密闭保存。',
          packaging: '塑料瓶，每瓶28g',
          validity: '60个月',
          standard: '国家药品标准WS1-（X-030）-2001Z',
          approvalNumber: '国药准字H20013294',
          manufacturer: '曼秀雷敦（中国）药业有限公司',
          imgUrl: 'https://cdn.youjiajk.com/appfile/drug2.png'
        }, {
          commonName: '复方消化酶胶囊',
          productName: '',
          englishName: 'Compound Digestive Enzyme Capsules',
          chineseName: 'Fufang Xiaohuamei Jiaonang',
          ingredient: '本品为复方制剂，每粒含胃蛋白酶25毫克、木瓜酶50毫克、淀粉酶15毫克、熊去氧胆酸25毫克、纤维素酶15毫克、胰蛋白酶2550美国药典单位、胰淀粉酶2550美国药典单位、胰脂肪酶412美国药典单位。辅料为：淀粉、糊精、羧甲淀粉钠、硬脂酸镁、微晶纤维素、交联羧甲基纤维素钠、聚乙烯吡咯烷酮。',
          character: '本品为无色透明硬胶囊，内含橙、白色薄膜衣与绿色肠溶衣的三种柱形片。',
          category: '',
          indication: '用于食欲缺乏、消化不良，包括腹部不适、嗳气、早饱、餐后腹胀、恶心、排气过多、脂肪便，也可用于胆囊炎和胆结石以及胆囊切除患者的消化不良。',
          specification: '',
          function: '',
          usage: '<span>口服，每次1~2粒，一日3次，饭后服。</span>',
          adverse: '<p>1.有呕吐、泄泻、软便。</p><p>2.可能发生口内不快感。</p>',
          taboo: '<span>急性肝炎患者及胆道完全闭锁患者禁用。</span>',
          announcements: '<p>1.儿童用量请咨询医师或药师。</p><p>2.服用时可将胶囊打开，但不可嚼碎药片。</p><p>3.对本品过敏者禁用,过敏体质者慎用。</p><p>4.本品性状发生改变时禁止使用。</p><p>5.请将本品放在儿童不能接触的地方。</p><p>6.儿童必须在成人监护下使用。</p><p>7.如正在使用其他药品，使用本品前请咨询医师或药师。。</p>',
          interaction: '<p>1.铝制剂可能影响本品疗效。</p><p>2.如与其他药物同时使用可能发生药物相互作用，详情请咨询医师或药师。</p>',
          Pharmacology: '本品中胃蛋白酶能使蛋白质分解成蛋白胨和多肽；木瓜酶可水解动植物蛋白，提高蛋白质利用率，淀粉酶能直接使淀粉分解为易于吸收的糊精与麦芽糖；熊去氧胆酸能增加胆汁分泌，提高胰酶活性，促进食物中脂肪乳化；纤维素酶能降解植物细胞壁，促进营养物质的消化吸收，并能激活胃蛋白酶；胰酶及胰酯酶能将脂肪降解为甘油和脂肪酸，将蛋白质分解为蛋白胨，将淀粉分解为糊精和糖，从而促进食物消化，驱除肠内气体、消除腹部胀满。',
          depot: '密封，室温保存',
          packaging: '铝塑泡罩包装，10粒/板×3板/盒',
          validity: '24个月',
          standard: '国家药品标准YBH08172006',
          approvalNumber: '国药准字H20064646',
          manufacturer: '北京星昊医药股份有限公司',
          imgUrl: 'https://cdn.youjiajk.com/appfile/drug3.png'
        }, {
          commonName: '聚乙烯醇滴眼液',
          productName: '瑞珠',
          englishName: 'Polyvinyl Alcohol Eye Drops',
          chineseName: 'Juyixichun Diyanye',
          ingredient: '本品每毫升含聚乙烯醇14毫克，辅料为：氯化钠、氯化钾、磷酸氢二钠、磷酸二氢钠、甘油、羟苯乙酯、注射用水。',
          character: '本品为无色微黏稠的澄明液体。',
          category: '本品为眼科用药类非处方药药品。',
          indication: '可作为一种润滑剂预防或治疗眼部干涩、异物感、眼疲劳等刺激症状或改善眼部的干燥症状。',
          specification: '0.8毫升:11.2毫克(以聚乙烯醇计)',
          usage: '<span>每次一滴，滴于患眼。</span>',
          function: '',
          adverse: '<span>偶有眼部刺激症状和过敏反应。</span>',
          taboo: '<span>对本品过敏者禁用。</span>',
          announcements: '<p>1.勿让滴嘴接触任何物体表面以避免污染，用后请盖好瓶盖。</p><p>2.滴眼后若觉眼痛、视力模糊、眼部持续充血或刺激症状或病情加重，且持续时间超过72小时，应停止使用或向医生咨询。</p><p>3.若药液变色或浑浊，勿再使用。</p><p>4.配戴软性隐形眼镜时请将隐形眼镜摘下后滴用本品</p><p>5.对本品过敏者禁用，过敏体质者慎用。</p><p>6.本品性状发生改变时禁止使用。</p><p>7.请将本品放在儿童不能接触的地方。</p><p>8.儿童必须在成人监护下使用。</p><p>9.如正在使用其他药品，使用本品前请咨询医师或药师。</p><p>10.本品不含防腐剂，开启后仅限当日使用。</p>',
          interaction: '<span>如正在使用其他药品，使用本品前请咨询医师或药师。</sp>',
          Pharmacology: '本品属高分子聚合物。具有亲水性，在适宜浓度下，能起类似人工泪液的作用。',
          depot: '密闭（10~30℃）保存。',
          packaging: '低密度聚乙烯药用滴眼剂瓶。0.8毫升/支，10支/盒。',
          validity: '24个月',
          standard: '国家药品标准新药转正标准第35册WS3-(X-081)-2003Z',
          approvalNumber: '国药准字H20046681',
          manufacturer: '湖北远大天天明制药有限公司',
          imgUrl: 'https://cdn.youjiajk.com/appfile/drug4.png'
        }, {
          commonName: '六味地黄丸', //能用名称
          productName: '', //商品名称
          englishName: '', //英文名称
          chineseName: 'Liuwei Dihuang Wan', //汉语拼音
          ingredient: '熟地黄、山茱萸(制)、牡丹皮、山药、茯苓、泽泻。', //成份
          character: '本品为棕褐色或亮黑色的浓缩丸；味微甜，酸，略苦。', // 性状
          category: '', //作用类别
          indication: '', // 适应症
          specification: '每8丸重1.44g(每8丸相当于饮片3g)。', //规格
          function: '滋阴补肾。用于头晕耳鸣，腰膝酸软，遗精盗汗。', //功能主治
          usage: '<span>口服。一次8丸，一日3次。</span>', //用法与用量
          adverse: '<span>尚不明确</span>', //不良反应
          taboo: '<span>尚不明确</span>', //禁忌
          announcements: '<p>1.忌辛辣食物。</p><p>2.不宜在服药期间服用感冒药。</p><p>3.服药期间出现食欲不振、胃脘不适、大便稀、腹痛等症状时，应去医院就诊。</p><p>4.服药二周后症状未改善，应去医院就诊。</p><p>5.按照用法用量服用，孕妇、小儿应在医师指导下服用。</p><p>6.对本品过敏者禁用，过敏体质者慎用。</p><p>7.本品性状发生改变时禁止使用。</p><p>8.儿童必须在成人监护下使用。</p><p>9.请将本品放在儿童不能接触的地方。</p><p>10.如正在使用其他药品，使用本品前请咨询医师或药师。</p>', //注意事项
          interaction: '<span>如与其他药物同时使用可能会发生药物相互作用，详情请咨询医师或药师。</span>', //药物相互作用
          Pharmacology: '', //药理作用
          depot: '密封', //贮藏
          packaging: '塑料瓶装，每瓶装120丸', //包装
          validity: '48个月', //有效期
          standard: '《中国药典》2010年版一部', //执行标准
          approvalNumber: '国药准字Z19993068', //批准文号
          manufacturer: '北京同仁堂科技发展股份有限公司制药厂', //生产厂家
          imgUrl: 'https://cdn.youjiajk.com/appfile/drug5.png'
        }, {
          commonName: '维D钙咀嚼片', //能用名称
          productName: '迪巧', //商品名称
          englishName: 'Calcium Supplement with Vitamin D Chewable Tablets', //英文名称
          chineseName: 'Wei D Gai Ju Jue Pian', //汉语拼音
          ingredient: '本品为复方制剂，每片含碳酸钙0.75克（相当于钙300毫克），维生素D3 100国际单位。辅料为：山梨酸醇、硬脂酸镁、水果香精、着色剂。', //成份
          character: '淡粉红色，水果香味，椭园形咀嚼片。', // 性状
          category: '本品为维生素与矿物质类非处方药药品。', //作用类别
          indication: '用于妊娠、哺乳妇女，更年期妇女、老年人等的钙补充，也用于防治骨质疏松。', // 适应症
          specification: '每片含维生素D3 100IU（2.5μg），碳酸钙750毫克(相当于钙300毫克)。', //规格
          function: '', //功能主治
          usage: '<span>口服，咀嚼后咽下。儿童，一次1片；成人，一次2片；一日1次。</span>', //用法与用量
          adverse: '<p>1．嗳气、便秘。</p><p>2．过量服用可发生高钙血症，奶-碱综合征，表现为高血钙，碱中毒及肾功能不全（因服用牛奶及碳酸钙或单用碳酸钙引起）。</p>', //不良反应
          taboo: '<span>高钙血症、高尿酸血症、含钙肾结石或有肾结石病史者禁用。</span>', //禁忌
          announcements: '<p>1.心肾功能不全者慎用。</p><p>2.如服用过量或出现严重不良反应，应立即就医。</p><p>3.对本品过敏者禁用，过敏体质者慎用。</p><p>4.本品性状发生改变时禁止使用。</p><p>5.请将本品放在儿童不能接触的地方。</p><p>6.儿童必须在成人监护下使用。</p><p>7.如正在使用其他药品，使用本品前请咨询医师或药师。</p><p>8.肾结石患者应在医师指导下使用。</p>', //注意事项
          interaction: '<p>1.本品不宜与洋地黄类药物合用。</p><p>2.大量饮用含酒精和咖啡 因的饮料以及大量吸烟，均会抑制钙剂的吸收。</p><p>3.大量进食富含纤维素的食物能抑制钙的吸收，因钙与纤维素结合成不易吸收的化合物。</p><p>4.本品与苯妥英钠类及四环素类同用，二者吸收减低。</p><p>5.维生素D、避孕药、雌激素能增加钙的吸收。</p><p>6.含铝的抗酸药与本品同服时，铝的吸收增多。</p><p>7.本品与噻嗪类利尿药合用时，因增加肾小管对钙的重吸收而易发生高钙血症。</p><p>8.本品与含钾药物合用时，应注意心律失常。</p><p>9.如与其他药物同时使用可能会发生药物相互作用，详情请咨询医师或药师。</p>', //药物相互作用
          Pharmacology: '钙是维持人体神经、肌肉、骨骼系统、细胞膜和毛细血管通透性正常功能所必需。维生素D能参与钙和磷的代谢，促进其吸收并对骨质形成有重要作用。', //药理作用
          depot: '密闭干燥处保存', //贮藏
          packaging: '塑料瓶，每瓶60片，且瓶内有药用固体纸袋装硅胶干燥剂。', //包装
          validity: '24个月', //有效期
          standard: '《中国药典》2010年版一部', //执行标准
          approvalNumber: '国药准字J20140154', //批准文号
          manufacturer: '安士制药(中山)有限公司', //生产厂家
          imgUrl: 'https://cdn.youjiajk.com/appfile/drug6.png'
        }, {
          commonName: '盐酸特比萘芬乳膏', //能用名称
          productName: '丁克', //商品名称
          englishName: 'Terbinafine Hydrochloride Cream', //英文名称
          chineseName: 'Yansuan Tebinaifen RuGao', //汉语拼音
          ingredient: '每克含主要成分盐酸特比萘芬0.02克，辅料为：白凡士林、丙二醇、聚山梨脂80、单、双硬脂酸甘油酯、硬脂酸。', //成份
          character: '本品为白色或类白色乳膏。', // 性状
          category: '本品为皮肤科用药类非处方药药品。', //作用类别
          indication: '用于治疗手癣、足癣、体癣、股癣、花斑癣及皮肤念珠菌病等。', // 适应症
          specification: '20克:0.2克', //规格
          function: '', //功能主治
          usage: '<span>外用，一日2次，涂患处，并轻揉片刻。疗程1-2周。</span>', //用法与用量
          adverse: '<span>偶见皮肤刺激如烧灼感，或过敏反应如皮疹、瘙痒等。</span>', //不良反应
          taboo: '<span>尚不明确</sp>', //禁忌
          announcements: '<p>1.孕妇及哺乳期妇女慎用。</p><p>2.避免接触眼睛和其他黏膜（如口、鼻等）。</p><p>3.用药部位如有烧灼感、红肿等情况应停药，并将局部药物洗净，必要时向医师咨询。</p><p>4.本品涂敷后不必包扎。</p><p>5.不得用于皮肤破溃处。</p><p>6.对本品过敏者禁用，过敏体质者慎用。</p><p>7.本品性状发生改变时禁止使用。</p><p>8.请将本品放在儿童不能接触的地方。</p><p>9.儿童必须在成人监护下使用。</p><p>10.如正在使用其它药品，使用本品前请咨询医师或药师。</p>', //注意事项
          interaction: '<span>如与其它药物同时使用可能会发生药物相互作用，详情请咨询药师或医师。</span>', //药物相互作用
          Pharmacology: '本品为广谱抗真菌药，能高度选择性地抑制真菌麦角鲨烯环氧化酶，阻断真菌细胞膜形成过程中的麦鲨烯环氧化反应而干扰真菌固醇的早期生物合成，从而发挥抑制和杀灭真菌的作用。', //药理作用
          depot: '密闭，置阴凉处（不超过20℃）保存。', //贮藏
          packaging: '铝管包装，1支/盒。', //包装
          validity: '36个月', //有效期
          standard: '《中国药典》2015年版二部及WS1-(X-115)-2004Z', //执行标准
          approvalNumber: '国药准字H10970136', //批准文号
          manufacturer: '齐鲁制药有限公司', //生产厂家
          imgUrl: 'https://cdn.youjiajk.com/appfile/drug7.png'
        }, {
          commonName: '叶酸片', //能用名称
          productName: '斯利安', //商品名称
          englishName: 'Folic Acid Tablets', //英文名称
          chineseName: 'Yesuan Pian', //汉语拼音
          ingredient: '本品每片含叶酸0.4毫克。辅料为：淀粉、乳糖、硬脂酸镁。', //成份
          character: '本品为黄色或橙黄色片。', // 性状
          category: '本品为维生素类非处方药品。', //作用类别
          indication: '<p>1.预防胎儿先天性神经管畸形。</p><p>2.妊娠期、哺乳期妇女预防用药。</p>', // 适应症
          specification: '0.4mg。', //规格
          function: '', //功能主治
          usage: '<p>1.预防胎儿先天性神经管畸形：口服，育龄妇女从计划怀孕时起至怀孕后三个月末，一次0.4mg，一日1次。</p><p>2.妊娠期、哺乳期妇女预防用药：一次0.4mg，一日1次。</p>', //用法与用量
          adverse: '<span>不良反应较少，罕见过敏反应。长期用药可出现畏食、恶心、腹胀等胃肠道症状。大量服用叶酸时，可使尿液呈黄色。</span>', //不良反应
          taboo: '<span>对本品过敏者禁用</span>', //禁忌
          announcements: '<p>1.请严格按照用法用量服用，如需加量，请咨询医师。</p><p>2.服用本品期间，服用其他含有叶酸的复合维生素类药物或保健食品请咨询医师。</p><p>3.对本品过敏者禁用，过敏体质者慎用。</p><p>4.本品性状发生改变时禁止使用。</p><p>5.请将本品放在儿童不能接触的地方。</p><p>6.如正在使用其他药品，使用本品前请咨询医师或药师。</p>', //注意事项
          interaction: '<p>1.大剂量叶酸能拮抗苯巴比妥、苯妥英钠和扑米酮的抗癫痫作用，可使癫痫发作的临界值明显降低，并使敏感患者的发作次数增多</p><p>2.口服大剂量叶酸，可以影响微量元素锌的吸收。</p><p>3.如与其他药物同时使用可能会发生药物相互作用，详情请咨询医师或药师。</p>', //药物相互作用
          Pharmacology: '叶酸是一种水溶性B族维生素，为人体细胞生长和繁殖的必须物质。本品经二氢叶酸还原酶及维生素B12的作用，形成四氢叶酸，后者与多种一碳单位（包括CH3、CH2、CH0等）结合成四氢叶酸类辅酶，传递一碳单位，参与体内很多重要反应及核酸和氨基酸的合成。', //药理作用
          depot: '遮光，密封保存。', //贮藏
          packaging: '铝塑泡罩包装，0.4mg*31片*3板。', //包装
          validity: '36个月', //有效期
          standard: '《中华人民共和国药典》2015年版二部', //执行标准
          approvalNumber: '国药准字H10970079', //批准文号
          manufacturer: '北京斯利安药业有限公司', //生产厂家
          imgUrl: 'https://cdn.youjiajk.com/appfile/drug8.png'
        }],
        dataInfo: {}
      }
    },
    created() {
      this._isMobile = this.$util._isMobile()
      this.dataInfo = this.detailInfo[this.$route.query.id]
    },
  }
</script>

<style scoped lang="less">
  .drugInfo {
    font-size: 16px;
    color: #333;
    line-height: 22px;

    .wrapperPc {
      display: flex;
      flex-wrap: wrap;
      margin: 36px auto 60px auto;
      width: 1221px;

      .title {
        width: 100%;
        background: #F4F4F8;
        height: 58px;
        font-size: 20px;
        color: #333;
        padding-left: 24px;
        line-height: 58px;
        font-weight: 600;
      }

      .nameTitle {
        width: 100%;
        font-size: 26px;
        color: #333;
        font-weight: 600;
        margin: 30px 0 24px;
      }

      .imgUrlStyle {
        width: 317px;
        height: 324px;
        border: 1px solid #DADADA;
        padding: 15px;
        margin-right: 30px;
      }

      .desc {
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 28px;
      }
      .disflex {
        display: flex;
      }

    }

    .wrapperMobile {
      .title {
        height: 0.7rem;
        background: #F4F4F8;
        font-size: 0.3rem;
        line-height: 0.7rem;
        color: #333;
        padding-left: .4rem;
        margin-top: 0.2rem;
        margin: 0.2rem 0.2rem 0.3rem;
        font-weight: 600;
      }
      .nameTitle{
        font-size: 0.24rem;
        font-weight: bold;
        margin: 0 0.2rem;
      }
      .disflex{
        margin: 0 0.2rem;
        .imgUrlStyle{
          width: 3.17rem;
          height: 3.24rem;
          border: 1px solid #DADADA;
          padding: 0.09rem 0.15rem;
          margin-top: 0.21rem;
        }
        .desc {
          margin-top: 0.18rem;
          font-size: 0.24rem;
          color: #333;
          margin-bottom: 0.8rem;
          line-height: 0.28rem;
        }
      }
    }

    

    .wrapperMobile {}

    .productItem {}
  }
</style>


// WEBPACK FOOTER //
// src/views/drugDetail.vue